import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import GrantForm from "./components/GrantForm";
import PawnerForm from "./components/PawnerForm";
import Renew from "./components/Renew";
import Renewgrant from "./components/Renewgrant";
import Renewpawner from "./components/Renewpawner";
import Enquiry from "./components/Enquiry";
import FastRenew from "./components/FastRenew";
import Redeem from "./components/Redeem";
import Other from "./components/Other";
import ChangeGoldValue from "./components/ChangeGoldValue";
import AdjustGrant from "./components/AdjustGrant";
import AdjustPawner from "./components/AdjustPawner";
import Adjust from "./components/Adjust.js";
import PoliceSeizeForm from "./components/PoliceSeizeForm.js";
import ReportLostForm from "./components/ReportLostForm.js";
import PrintLostForm from "./components/PrintLostForm.js";
import PrintReport from "./components/PrintReport.js";
import StockSummaryPage from "./components/StockSummaryPage.js";
import ChangeDate from "./components/ChangeDate.js";
import AddCustomerForm from "./components/AddCustomerForm.js";
import CancelRedeem from "./components/CancelRedeem.js";
import PawnerIntake from "./components/PawnerIntake.jsx";
import AdminOcrIntake from "./components/AdminOcrIntake.js";
import ApkDownload from "./components/ApkDownload";
import TerrorImport from "./components/TerrorImport";
import NameSearch from "./components/NameSearch";
import DaySummary from "./components/DaySummary.js";
import TicketDetails from "./components/TicketDetails.js"
import EnquiryHome from "./components/EnquiryHome.js";
import EnquiryMonths from "./components/EnquiryMonths.js";
import EnquiryResults from "./components/EnquiryResults.js";
import EnquirySearch from "./components/EnquirySearch.js";
import NamePick from "./components/NamePick.js";
import RenewalSummary from "./components/RenewalSummary.js";
import ExpiredTickets from "./components/ExpiredTickets.js";
import CancelLost from "./components/CancelLost.js";
import EnquiryRedeemed from "./components/EnquiryRedeemed.js";
import NricAudit from "./components/NricAudit";
import ActiveVaultPage from "./components/ActiveVaultPage";
import StockSummary9MPage from "./components/StockSummary9MPage";
import ForfeitedByMmyyPage from "./components/ForfeitedByMmyyPage";
import CancelRenew from "./components/CancelRenew.js";
import AdjustPayment from "./components/AdjustPayment.js";
import DeleteRenewalRecord from "./components/DeleteRenewalRecord";
import CancelRenewByNew from "./components/CancelRenewByNew.js";
import DeleteGrant from "./components/DeleteGrant";
import PrivacyPolicy from "./components/PrivacyPolicy.jsx";
import EnquiryRedeemBy from "./components/EnquiryRedeemBy.jsx";
import ReceiptPrinter from "./components/ReceiptPrinter.js";
import PoliceReturnForm from "./components/PoliceReturnForm.js";

// --- NEW IMPORTS ---
import CancelGrant from "./components/CancelGrant";
import InsertRenewalRecord from "./components/InsertRenewalRecord";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/grant" element={<GrantForm />} />
        <Route path="/pawner-form" element={<PawnerForm />} />
        <Route path="/renew" element={<Renew />} />
        <Route path="/renew-grant" element={<Renewgrant />} />
        <Route path="/renew-pawner" element={<Renewpawner />} />
        {/* <Route path="/enquiry" element={<Enquiry />} /> */}
        <Route path="/fast-renew" element={<FastRenew />} />
        <Route path="/redeem" element={<Redeem />} />
        <Route path="/other" element={<Other />}/>
        <Route path="/change-gold-value" element={<ChangeGoldValue />} />
        <Route path="/adjust-grant" element={<AdjustGrant />}/>
        <Route path="/adjust-pawner" element={<AdjustPawner/>} />
        <Route path="adjust" element={<Adjust/>}/>
        <Route path="/police-seized" element={<PoliceSeizeForm/>}/>
        <Route path="/report-lost" element={<ReportLostForm/>}/>
        <Route path="/print-lost-form1" element={<PrintLostForm/>}/>
        <Route path="/print-report" element={<PrintReport/>}/>
        <Route path="/stock-summary" element={<StockSummaryPage/>}/>
        <Route path="/change-date" element={<ChangeDate/>}/>
        <Route path="/add-customer" element={<PawnerIntake />} />
        <Route path="/cancel-redeem" element={<CancelRedeem />} />
        <Route path="/admin-ocr-intake" element={<AdminOcrIntake />} />        
        <Route path="/app" element={<ApkDownload />} />
        <Route path="/terror-import" element={<TerrorImport />} />
        <Route path="/name-search" element={<NameSearch />} />
        <Route path="/day-summary" element={<DaySummary />} />
        {/* <Route path="/ticket-details" element={<TicketDetails/>} /> */}
        <Route path="/ticket/:receiptNo" element={<TicketDetails />} />    
        <Route path="/enquiry" element={<EnquiryHome />} />
        <Route path="/enquiry/:mode" element={<EnquirySearch />} />          
        <Route path="/enquiry/:mode/months" element={<EnquiryMonths />} />   
        <Route path="/enquiry/:mode/results" element={<EnquiryResults />} />
        <Route path="/enquiry/name/pick" element={<NamePick />} />   
        <Route path="/renewal-summary" element={<RenewalSummary />} />
        <Route path="/expired" element={<ExpiredTickets />} />
        <Route path="/cancel-lost" element={<CancelLost />} />
        <Route path="/enquiry/redeemed" element={<EnquiryRedeemed />} />
        <Route path="/management-dashboard" element={<h1>Management Dashboard</h1>} />
        <Route path="/nric-audit" element={<NricAudit />} />
        <Route path="/active-vault" element={<ActiveVaultPage />} />
        <Route path="/stock-summary-9m" element={<StockSummary9MPage />} />
        <Route path="/forfeited-mmyy" element={<ForfeitedByMmyyPage />} />
        <Route path="/cancel-renew" element={<CancelRenew />} />
        <Route path="/adjust-payment" element={<AdjustPayment />} />
        <Route path="/delete-renewal-record" element={<DeleteRenewalRecord />} />
        <Route path="/cancel-renew-by-new" element={<CancelRenewByNew />} />
        <Route path="/delete-grant" element={<DeleteGrant />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/enquiry/redeem-by" element={<EnquiryRedeemBy />} />
        <Route path="/print-receipt" element={<ReceiptPrinter />} />
        <Route path="/police-return" element={<PoliceReturnForm />} />
        
        {/* --- NEW ROUTES --- */}
        <Route path="/cancel-grant" element={<CancelGrant />} />
        <Route path="/insert-renewal-record" element={<InsertRenewalRecord />} />

      </Routes>
    </Router>
  );
}

export default App;